import React from 'react'
import Data from '../assets/data'
import { useParams } from 'react-router-dom'
import { Fade } from "react-slideshow-image";
import {
    Link
} from "react-router-dom";

const properties = {
    duration: 5000,
    transitionDuration: 700,
    infinite: true,
    prevArrow:  <div style={{width: "30px", marginRight: "-30px"}} className="h-10 text-xl text-purple-600 flex items-center justify-center bg-purple-200 rounded hover:text-white hover:bg-purple-600 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                </div>,
    nextArrow:  <div style={{width: "30px", marginLeft: "-30px"}} className="h-10 text-xl text-purple-600 flex items-center justify-center bg-purple-200 rounded hover:text-white hover:bg-purple-600 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </div>,
};

function ProjectDetail(){
    const { id } = useParams()
    var project = Data.projects[id]  
    var link = project.link
    return (
        <section className="pb-10">
            <div className="flex flex-wrap md:px-4">
                    <div className="w-full">
                        <div className="my-4 md:mx-4 shadow p-6 rounded-md bg-white group hover:shadow-md">
                            <Link className="w-12 h-10 text-xl text-purple-600 flex items-center justify-center bg-purple-200 rounded hover:text-white hover:bg-purple-600 mb-4" exact to={"/project/"}>
                                <svg stroke="currentColor" fill="currentColor" strokeWidth={0} viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                </svg>
                            </Link>
                            <div className="slide-container relative mb-6 w-full h-full rounded-md overflow-hidden">
                                <Fade {...properties}>
                                    {Object.keys(project.images).map((key) => (
                                        <div className="each-fade">
                                            <img className="w-full h-full object-cover object-center" src={project.images[key]} />
                                            {link
                                                ? <div className="absolute opacity-0 transition duration-200 bg-purple-100 bg-opacity-20 w-full flex items-center justify-center h-full left-0 top-0 group-hover:opacity-100 group-hover:visible">
                                                    <ul className="flex flex-wrap">
                                                        <li className="m-2">
                                                        <a href={project.link} className="w-12 h-10 text-xl text-purple-600 flex items-center justify-center bg-purple-200 rounded hover:text-white hover:bg-purple-600 mb-4">
                                                            <svg stroke="currentColor" fill="currentColor" strokeWidth={0} viewBox="0 0 496 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" />
                                                            </svg>
                                                        </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                : <div></div>
                                            }

                                        </div>
                                    ))}
                                </Fade>
                            </div>
                            <h3 className="text-xl font-medium text-purple-800">{project.title}</h3>
                            <p className="text-gray-700 mb-2">{project.desc}</p>
                            {project.detail}
                        </div>
                    </div>
            </div>
        </section>
    )
}
  
export default ProjectDetail
